import { Base } from 'firepuma-vue-axios-vuex-extensions/axios-utils/apiBase';

export class Api extends Base {
  async saveEggOrder(id, quantities) {
    let payload = {
      quantities: quantities,
    };
    const response = await this.api().put(`v1/sales/egg-orders/${encodeURIComponent(id)}`, payload);
    return this.handleResponse(response);
  }
}

export const SalesAPI = new Api();



// WEBPACK FOOTER //
// ./src/sales/api.js